import { render, staticRenderFns } from "./OrderViewLogModal.vue?vue&type=template&id=15de6f70&"
import script from "./OrderViewLogModal.vue?vue&type=script&lang=js&"
export * from "./OrderViewLogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports